import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DECLINE } from 'mgiriskangularsdk/constant/constants';
import { interval, Subject, Subscription, takeUntil } from 'rxjs';
import { Labels } from 'src/app/app.models';

@Component({
    selector: 'app-id-verification-confirmation',
    templateUrl: './id-verification-confirmation.component.html',
    styleUrls: ['./id-verification-confirmation.component.scss'],
    standalone: false
})
export class IdVerificationConfirmationComponent {
  @Output() timerCompleteEvent = new EventEmitter<void>()

  @Input() risk: 'ALLOW' | 'DECLINE' | 'WAIT' | null = null
  @Input() cmsLabels: Labels
  @Input() timerClickSubject: Subject<string>

  public timeRemaining: number = 5
  private timerSubscription$: Subscription

  private destroy$: Subject<void> = new Subject<void>()

  // Todo: Tim: #refactor - timer logic could be extracted into a separate component
  ngOnInit() {
    this.timerClickSubject
      // .pipe(takeUntil(this.destroy$))
      .subscribe((event) => {
        console.log('EVENT emitted from observable', event) // remove: Tim: #may6
        if (this.risk === 'DECLINE') return
        else if (event === 'start') {
          console.log('running startTimer()') // remove: Tim: #may6
          this.startTimer()
        }
      })
  }

  ngOnDestroy(): void {
    if (this.timerSubscription$) { this.timerSubscription$.unsubscribe() }
    this.destroy$.next()
    this.destroy$.complete()
  }

  public getPageHeader(): string {
    if (this.risk === 'ALLOW') {
      return this.cmsLabels.stellar.signIn.riskSdk.youHaveBeenVerified
    }
    else if (this.risk === 'DECLINE') {
      return this.cmsLabels.stellar.signIn.riskSdk.canNotVerifyIdentity
    }
    else if (this.risk === 'WAIT') {
      return this.cmsLabels.stellar.signIn.riskSdk.applicationSubmitted
    }
    else {
      return ''
    }
  }

  public getPageHeaderHelpText1(): string {
    // if (this.risk === 'ALLOW') {
    //   return this.cmsLabels.stellar.signIn.riskSdk.youHaveBeenVerifiedHelpText
    // }
    // Todo: Tim: #may6 - for MVP, WAIT and ALLOW will have the same help text
    if (this.risk === 'ALLOW' || this.risk === 'WAIT') {
      return this.cmsLabels.stellar.signIn.riskSdk.youHaveBeenVerifiedHelpText
    }
    else if (this.risk === 'DECLINE') {
      return this.cmsLabels.stellar.signIn.riskSdk.canNotVerifyIdentityHelpText
    }
    // else if (this.risk === 'WAIT') {
    //   return this.cmsLabels.stellar.signIn.riskSdk.applicationSubmittedHelpText1
    // }
    else {
      return ''
    }
  }

  public getPageHeaderHelpText2(): string {
    if (this.risk === 'WAIT') {
      return this.cmsLabels.stellar.signIn.riskSdk.applicationSubmittedHelpText2
    }
    else {
      return ''
    }
  } 

  public getRedirectText(): string {
    return `${this.cmsLabels.stellar.signIn.riskSdk.redirectingYouIn.replace('%s', this.timeRemaining.toString())}`
  }

  public startTimer() {
    console.log('startTimer timer...') // remove: Tim: #may6
    if (!this.timerSubscription$ || this.timerSubscription$.closed) {
      this.timerSubscription$ = interval(1000).subscribe(() => {
        if (this.timeRemaining > 0) {
          this.timeRemaining--
        }
        else {
          this.timerCompleteEvent.emit()
          this.timerSubscription$.unsubscribe()
        }
      })
    }
  }


}
